import React, { useCallback } from 'react';
import styles from './Switch.module.scss';

type Props = {
  enabled: boolean;
  onChange: (value: boolean) => void;
  label?: string;
  disabled?: boolean;
};

function Switch(props: Props) {
  const { enabled, onChange, disabled } = props;

  const handleChange = useCallback(() => {
    if (disabled) {
      return;
    }
    onChange(!enabled);
  }, [enabled, onChange, disabled]);

  return (
    <div className={[styles.wrapper, enabled ? styles.active : '', disabled ? styles.disabled : ''].join(' ')} onClick={handleChange}>
      {!enabled ? <div className={styles.ball}></div> : null}
      <span className={[styles.label, enabled ? styles.active: '', disabled ? styles.disabled : ''].join(' ')}>{enabled ? 'Faith Content Enabled' : 'Faith Content Disabled'}</span>
      {enabled ? <div className={styles.greenBall}></div> : null}
    </div>
  );
}

export default Switch;
